/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { type Meta, type StoryObj } from '@storybook/react-vite';

import { SideNavigation } from '../index';
import {
  SideNavBadges,
  SideNavBadgesSrc,
  SideNavCompact,
  SideNavCompactSrc,
  SideNavDefault,
  SideNavDefaultSrc,
  SideNavSecondary,
  SideNavSecondarySrc,
} from '.';

const componentMeta = {
  component: SideNavigation,
  parameters: {
    controls: { disable: true },
  },
  tags: ['docsPage'],
  title: 'Components/SideNavigation',
  id: 'components-side-navigation',
} satisfies Meta<typeof SideNavigation>;

export default componentMeta;
type Story = StoryObj<typeof componentMeta>;

export const Default: Story = {
  // @ts-expect-error - we don't use args
  args: {},
  parameters: {
    docs: {
      source: {
        code: SideNavDefaultSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: SideNavDefault,
};

export const Compact: Story = {
  // @ts-expect-error - we don't use args
  args: {},
  parameters: {
    docs: {
      source: {
        code: SideNavCompactSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: SideNavCompact,
};

export const WithSecondaryNav: Story = {
  // @ts-expect-error - we don't use args
  args: {},
  parameters: {
    docs: {
      source: {
        code: SideNavSecondarySrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: SideNavSecondary,
};

export const WithBadges: Story = {
  // @ts-expect-error - we don't use args
  args: {},
  parameters: {
    docs: {
      source: {
        code: SideNavBadgesSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: SideNavBadges,
};
